module.exports = __webpack_public_path__ + "static/media/contractor-list.5faee1c3.svg";